import React, { useEffect, useState } from "react";
import Styles from "./job.module.scss";
import tick from "../../../../../images/tick.svg";
import Upload from "../../../../../images/upload.svg";
import Cross from "../../../../../images/cross.svg";
import BlueClose from "../../../../../images/bluecross.svg";
import { AutoComplete, Select, notification } from "antd";
import { functionService } from "../../../../../lib/functions";
import { useParams, useSearchParams } from "react-router-dom";
let duration = [
    {
        name: "Longer than 12 months",
        value: "Longer than 12 months",
    },
    {
        name: "6 to 12 months",
        value: "6 to 12 months",
    },
    {
        name: "3 to 6 months",
        value: "3 to 6 months",
    },
    {
        name: "Less than 3 months",
        value: "Less than 3 months",
    },
];
let expectedStartConstant = [
    {
        name: "Immediately",
        value: "Immediately",
        selected: false,
    },
    {
        name: "In 1 to 2 weeks",
        value: "In 1 to 2 weeks ",
        selected: false,
    },
    {
        name: "More than 2 weeks from now",
        value: "More than 2 weeks from now",
        selected: false,
    },
    {
        name: "I’ll decide later",
        value: "I’ll decide later",
        selected: false,
    },
];

let expConstants = [
    {
        name: "1 to 2 years",
        value: "1 to 2 years",
        selected: false,
    },
    {
        name: "2 to 5 years",
        value: "2 to 5 years",
        selected: false,
    },
    {
        name: "5 to 7 years",
        value: "5 to 7 years",
        selected: false,
    },
    {
        name: "More than 7 years",
        value: "More than 7 years",
        selected: false,
    },
];
let budgetConstants = [
    {
        name: "Less than $20/hour",
        value: "Less than $20/hour",
        selected: false,
    },
    {
        name: "$20 - $40/hour",
        value: "$20 - $40/hour ",
        selected: false,
    },
    {
        name: "$40 - $70/hour",
        value: "$40 - $70/hour",
        selected: false,
    },
    {
        name: "More than $70/hour",
        value: "More than $70/hour",
        selected: false,
    },
];

const JobRole = () => {
    const [JDName, setJDName] = useState();
    const [projectDuration, setProjectDuration] = useState();
    const [expectedStart, setExpectedStart] = useState();
    const [experience, setExperience] = useState();
    const [budget, setBudget] = useState();
    const [jdurl, setjdurl] = useState();
    const [skillOptions, setSkillOptions] = useState([]);
    const [autocompleteSkill, setAutoCompleteSkill] = useState();
    const [selectedSkill, setSelectedSkill] = useState([]);
    const [skillData, setSkillData] = useState([]);
    const [details, setDetails] = useState({});
    const [roleTitle, setRoleTitle] = useState();
    let { search_id } = useParams();

    const handleProjectDuration = (val) => {
        setProjectDuration(val);
    };
    const handleExpectedStart = (val) => {
        setExpectedStart(val);
    };
    const handleExperience = (val) => {
        setExperience(val);
    };
    const handleBudget = (val) => {
        setBudget(val);
    };
    const uploadHandler = async (event) => {
        if (event.target.files?.length) {
            const fileData = event.target.files[0];

            if (fileData.size >= 2 * 1000 * 1000) {
                notification["error"]({
                    message: "File size exceeded",

                    description: `File size can't be more than 2 MB!`,
                });
            } else if (
                fileData.name.toLowerCase().endsWith(".pdf") ||
                fileData.name.toLowerCase().endsWith(".doc") ||
                fileData.name.toLowerCase().endsWith(".docx")
            ) {
                let res = await functionService.uploadFile(fileData);

                if (res.status === true) {
                    setjdurl(res?.response?.data?.location);

                    setJDName(fileData?.name);
                }
            } else {
                // notification["error"]({
                //     message: "Unsupported file format",
                //     description: `Please select either doc file or pdf file!`,
                // });
            }
        }
    };
    const onSearchSkill = async (searchText) => {
        // if (searchText?.length == 0) {
        //     setoptionJobProfile([]);
        // } else {
        let res = await functionService.get(
            `recruiter/skills?name=${searchText}`
        );
        let suggestionsresult =
            res?.response?.data?.data?.skills?.length <= 0
                ? []
                : res?.response?.data?.data?.skills?.map((item) => ({
                      value: item.name,
                      name: item.name,
                      id: item.id,
                  }));
        setSkillOptions(!searchText ? [] : suggestionsresult);
        // }
    };
    const onSelection = (item) => {
        const index = selectedSkill?.findIndex((t) => t.id === item.id);
        if (index < 0) {
            setSelectedSkill([...selectedSkill, item]);
            if (!selectedSkill.includes(item.id)) {
                // ctx?.setState({
                //     ...ctx.state,
                //     secondStep: {
                //         ...ctx.state.secondStep,
                //         skills: [...selectedSkill, item],
                //     },
                // });
            }
        } else {
            const selectedCopy = Array.from(selectedSkill);
            selectedCopy?.splice(index, 1);
            setSelectedSkill(selectedCopy);
            const skillInd = skillData.findIndex((i) => i.id === item.id);
            const skillDataCopy = Array.from(skillData);
            skillDataCopy.splice(skillInd, 1);

            setSkillData(skillDataCopy);
            // ctx?.setState({
            //     ...ctx.state,
            //     secondStep: {
            //         ...secondStep,
            //         skills: selectedCopy,
            //     },
            // });
        }
    };
    const onAutocompleteSelection = (item) => {
        const index = selectedSkill?.findIndex((t) => t.id === item.id);

        if (index < 0) {
            setSelectedSkill([...selectedSkill, item]);

            if (
                !selectedSkill.includes(item.id) &&
                skillData?.findIndex((i) => i.id === item.id) === -1
            ) {
                setSkillData((prev) => {
                    return [...prev, item];
                });
            }
        }
    };
    const getCandidateSearchData = async () => {
        const response = await functionService.post(
            "recruiter/getcandidatedetails",
            {
                search_id: search_id,
            }
        );
        setProjectDuration(response?.response?.data?.data?.contract_duration);
        setBudget(response?.response?.data?.data?.budget);
        setExpectedStart(response?.response?.data?.data?.expected_start);
        setExperience(response?.response?.data?.data?.year_of_exp);
        setRoleTitle(response?.response?.data?.data?.recruiting_role_title);
        setJDName(
            response?.response?.data?.data?.job_desc
                ? decodeURIComponent(
                      response?.response?.data?.data?.job_desc.substring(
                          response?.response?.data?.data?.job_desc.lastIndexOf(
                              "/"
                          ) + 1
                      )
                  )
                : ""
        );
        setjdurl(response?.response?.data?.data?.job_desc)
        setSkillData(JSON.parse(response?.response?.data?.data?.skills));
        setSelectedSkill(JSON.parse(response?.response?.data?.data?.skills));
    };

    useEffect(() => {
        if (search_id) {
            getCandidateSearchData(search_id);
        }
    }, [search_id]);

    return (
        <div className={Styles.complete_container}>
            <p className={Styles.heading}>Search Candidate</p>
            <div className={Styles.container}>
                <p>What can we help you with?</p>
                <div className={Styles.box}>
                    Hire remote developers
                    <img src={tick} alt=""/>
                </div>
            </div>
            <div className={Styles.container}>
                <p>What role are you hiring for?</p>
                <div className={Styles.autocomplete}>
                    <input
                        className={Styles.role_input}
                        placeholder="eg; Full Stack Developer"
                        value={roleTitle}
                    />

                    {/* <ErrorText errorText={errorsObject?.role} /> */}
                </div>
                <p>What skills are you looking for?</p>
                <div className={Styles.autocomplete}>
                    <AutoComplete
                        style={{
                            width: 300,
                            height: 40,
                        }}
                        value={autocompleteSkill}
                        onSearch={onSearchSkill}
                        options={skillOptions}
                        onSelect={(val, option) => {
                            // onSelection(option);
                            onAutocompleteSelection(option);
                            setAutoCompleteSkill("");
                        }}
                        onChange={(e) => setAutoCompleteSkill(e)}
                        placeholder="Search"
                        // onChange={(e) => {
                        //     setData({ ...data, recruiting_role: e });
                        // }}
                    />
                    {/* <ErrorText errorText={errorsObject?.skills} /> */}
                </div>
                <div className={Styles.skill_wrapper}>
                    {skillData &&
                        skillData.map((item, i) => {
                            return (
                                <div
                                    className={
                                        selectedSkill.filter(
                                            (i) => i.id === item.id
                                        ).length === 1
                                            ? Styles.highlight_skill
                                            : ""
                                    }
                                    onClick={() => {
                                        onSelection(item);
                                    }}
                                >
                                    {item.name}
                                    {selectedSkill.map(
                                        (i) =>
                                            i.id === item.id && (
                                                <img
                                                    alt=""
                                                    className={
                                                        Styles.close_icon
                                                    }
                                                    src={BlueClose}
                                                />
                                            )
                                    )}
                                </div>
                            );
                        })}
                </div>
                <p>Job description</p>
                <div>
                    {JDName ? (
                        <p
                            className={Styles.upload_wrapper}
                            style={{ fontWeight: 700 }}
                            onClick={()=>{window.open(jdurl)}}
                        >
                            {JDName}
                            <img
                                style={{ marginLeft: "10px" }}
                                onClick={() => {
                                    setJDName(null);
                                    setjdurl(null);
                                }}
                                width={12}
                                height={12}
                                src={Cross}
                                alt=""
                            />
                        </p>
                    ) : (
                        <div className={Styles.expectedStartDateContainer}>
                            <label
                                for="upload"
                                className={Styles.upload_wrapper}
                            >
                                <input
                                    id="upload"
                                    // style={{ padding: "20px" }}
                                    hidden
                                    type="file"
                                    accept=".doc, .docx, .pdf"
                                    onChange={uploadHandler}
                                />
                                <div
                                    style={{
                                        display: "Flex",
                                        flexDirection: "column",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <p
                                        className={Styles.upload_text}
                                        style={{
                                            fontStyle: "normal",
                                            fontWeight: 600,
                                            fontSize: "12px",
                                            marginTop: "0px",
                                            marginBottom: "5px",
                                            color: "#1E2228",
                                        }}
                                    >
                                        {" "}
                                        Upload
                                    </p>
                                    <span
                                        style={{
                                            fontWeight: 400,
                                            fontSize: "12px",

                                            color: "#506D85",
                                        }}
                                    >
                                        {" "}
                                        File format : PDF, Doc, Docx
                                    </span>
                                </div>
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "#1b49ea",
                                        borderRadius: "8px",
                                        padding: "12px",
                                    }}
                                >
                                    <img alt="" src={Upload} />
                                </span>
                            </label>
                        </div>
                    )}
                </div>
            </div>
            <div
                className={`${Styles.left_right_container} ${Styles.container}`}
            >
                <div className={Styles.left_container}>
                    <div>
                        <p className={Styles.bold_text}>
                            How long do you need the developer for?
                        </p>
                        <div className={Styles.select}>
                            <Select
                                defaultValue="Select duration"
                                style={{ width: 120 }}
                                value={projectDuration}
                                onChange={handleProjectDuration}
                                options={duration}
                            />
                            {/* <ErrorText
                        errorText={
                            errorsObject.duration ? errorsObject.duration : ""
                        }
                    /> */}
                        </div>
                    </div>
                    <div>
                        <p className={Styles.bold_text}>
                            When do you need the developer to start?
                        </p>
                        <div className={Styles.select}>
                            <Select
                                defaultValue="Select duration"
                                style={{ width: 120 }}
                                value={expectedStart}
                                onChange={handleExpectedStart}
                                options={expectedStartConstant}
                            />
                            {/* <ErrorText
                        errorText={
                            errorsObject.duration ? errorsObject.duration : ""
                        }
                    /> */}
                        </div>
                    </div>
                </div>
                <div className={Styles.right_container}>
                    <div>
                        <p className={Styles.bold_text}>
                            Years of experience that you’re looking in the
                            developer?
                        </p>
                        <div className={Styles.select}>
                            <Select
                                defaultValue="Select duration"
                                style={{ width: 120 }}
                                value={experience}
                                onChange={handleExperience}
                                options={expConstants}
                            />
                            {/* <ErrorText
                        errorText={
                            errorsObject.duration ? errorsObject.duration : ""
                        }
                    /> */}
                        </div>
                    </div>
                    <div>
                        <p className={Styles.bold_text}>
                            Do you have any budget in mind?
                        </p>
                        <div className={Styles.select}>
                            <Select
                                mode="multiple"
                                defaultValue="Select duration"
                                value={budget}
                                onChange={handleBudget}
                                options={budgetConstants}
                            />
                            {/* <ErrorText
                        errorText={
                            errorsObject.duration ? errorsObject.duration : ""
                        }
                    /> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${Styles.container} ${Styles.btn_container}`}>
                <button className={Styles.search_btn}>Search Candidate</button>
            </div>
        </div>
    );
};

export default JobRole;
